import React, { FC } from 'react';
import { List } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { PaymentDetails, Terminal } from '~/types';
import PaymentDetailsCard from './PaymentDetailsCard';
import { useDeepEffect, usePath, usePermissions } from '~/hooks';
import theme from '~/theme';

interface Props {
  data: PaymentDetails[] | undefined;
  total: number;
  loading: boolean;
  terminalsById: Record<string, Terminal>;
}

const PaymentDetailsCards: FC<Props> = (props) => {
  const { data, loading, total, terminalsById } = props;
  const { pagination, changePath } = usePath();

  let column = 4;
  const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.xl });
  const isLaptop = useMediaQuery({ maxWidth: theme.breakpoints.xl });
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.md });
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.sm });
  if (isDesktop) column = 4;
  if (isLaptop) column = 3;
  if (isTablet) column = 2;
  if (isMobile) column = 1;

  const pageSize = column * 3;
  useDeepEffect(() => {
    changePath({ page: 1, perPage: pageSize });
  }, [pageSize]);

  const hasAccessView = usePermissions('business.paymentDetails.view');
  const hasAccessTerminalView = usePermissions('business.terminal.view');

  return (
    <List
      grid={{ gutter: 24, column }}
      dataSource={data}
      pagination={{
        pageSize,
        ...pagination,
        total,
      }}
      renderItem={(item) => (
        <List.Item key={item.id}>
          <PaymentDetailsCard
            data={item}
            loading={loading}
            hasAccessView={hasAccessView}
            hasAccessTerminalView={hasAccessTerminalView}
            terminal={terminalsById[item.terminalId]}
          />
        </List.Item>
      )}
    />
  );
};

export default PaymentDetailsCards;
